import { IonButton, IonButtons, IonHeader, IonIcon, IonTitle, IonToolbar } from '@ionic/react';
import { chevronBack } from 'ionicons/icons';
import React from 'react';
import { useHistory } from 'react-router';
import { DqText } from 'src/components/dq-text';
import { Chip, ChipProps } from '../Chip';
import './DesktopDetailPageHeader.scss';

interface MobileDesktopHeaderProps {
  /** The heading text. */
  heading?: string;
  /** The sub heading text. */
  subheading?: string;
  /** The props for the chip */
  chipProps?: ChipProps;
  /** The left side of the header. Can be any react element, or the literal value `true` to display the default back button. */
  left?: React.ReactNode;
  /** The right side of the header. Can be any react element. */
  right?: React.ReactNode;
}

export const DesktopDetailPageHeader: React.FC<MobileDesktopHeaderProps> = ({
  left,
  right,
  heading,
  subheading,
  chipProps,
}) => {
  const history = useHistory();

  return (
    <IonHeader className="desktop-detail-header">
      <IonToolbar className="desktop-detail-header__toolbar">
        {!!left && (
          <IonButtons slot="start">
            {left === true ? (
              <IonButton onClick={() => history.goBack()}>
                <IonIcon slot="icon-only" color="dark" size="large" icon={chevronBack} />
              </IonButton>
            ) : (
              left
            )}
          </IonButtons>
        )}
        {!!right && <IonButtons slot="end">{right}</IonButtons>}

        <IonTitle>
          <DqText variant="h1">
            <span>{heading}</span>
            {chipProps && (
              <span className="desktop-detail-header-chip">
                <Chip title={chipProps.title} type={chipProps.type} />
              </span>
            )}
          </DqText>
          {subheading && <DqText>{subheading}</DqText>}
        </IonTitle>
      </IonToolbar>
    </IonHeader>
  );
};

export default DesktopDetailPageHeader;
